module.exports = __webpack_public_path__ + "img/IT0000108145560.c5f8a955.png";